import React, { useContext, useEffect, useState } from 'react';
import { FaUserCircle, FaTrash,FaPlay, FaDollarSign, FaChartLine, FaSpotify, FaMusic, FaPersonBooth, FaFile, FaChartBar, FaPhotoVideo, FaBell, FaDatabase, FaUser, FaUpload, FaMoneyBill, FaSignOutAlt, FaPlus,FaUserEdit } from 'react-icons/fa';
import { MdGraphicEq } from 'react-icons/md';
import Header from '../components/Header';
import { AuthContext } from "../context/AuthContext";
import { DataContext } from "../context/DataContext";
import { Link, useNavigate } from "react-router-dom";
import WithdrawalRequestPopup from '../components/WithdrawalRequestPopup'
import UploadFilePopup from '../components/UploadFilePopup'
import { calculatePerformanceIncrease } from '../utils/calculationHelpers';
import PieChartComponent from '../components/charts/PieChartComponent';
import LineChartComponent from '../components/charts/LineChartComponent';
import PerformanceCard from '../components/PerformanceCard';

const AdminDashboardPage = () => {
    const authContext = useContext(AuthContext);
    const { getAdminDashboardData, applicationData, dataLoading } = useContext(DataContext);
    const navigate = useNavigate();
    const [mounted, setMounted] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [isUploadFilePopupOpen, setIsUploadFilePopupOpen] = useState(false);

    const { logout } = authContext;
    const withdrawRequest = (applicationData && applicationData.withdrawRequests !== undefined) ? JSON.parse(applicationData.withdrawRequests) : [];

    const handleOpenPopup = () => setIsOpen(true);
    const handleUploadFilePopup = () => setIsUploadFilePopupOpen(true);
    const handleClosePopup = () => setIsOpen(false);

    useEffect(() => {
        if (mounted) {
            getAdminDashboardData();
        }
        return () => setMounted(false);
    }, [mounted, getAdminDashboardData]);

    const performance = applicationData ? calculatePerformanceIncrease(applicationData.barchartdata, 'month') : {};

    return (
        <div className="bg-background relative">
            {dataLoading && (
                <div className="absolute inset-0 bg-background/30  flex justify-center items-center z-50">
                    <div className="spinner"></div>
                </div>
            )}
            <div className='absolute top-0 left-0 right-0'>
                <Header />
            </div>

            <WithdrawalRequestPopup isOpen={isOpen} onClose={handleClosePopup} />
            <UploadFilePopup isOpen={isUploadFilePopupOpen} onClose={() => setIsUploadFilePopupOpen(false)} />

            <div className="min-h-screen pt-28 py-6 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    {/* Header */}
                    <div className="bg-gradient-card border border-border/50 flex items-center justify-between mb-6 px-6 py-4 rounded-md">
                        <div className="flex items-center">
                            <FaUserCircle className="text-primary text-xl mr-2" />
                            <div>
                                <h1 className="text-xl font-semibold">Admin Portal</h1>
                                <p className="text-muted-foreground text-sm">Track Music's Performance</p>
                            </div>
                        </div>
                        <div className='flex flex-row items-center space-x-4'>
                            <Link to="/manage-content" title="Manage Website Content" className='text-foreground pr-2'><FaFile size={20} /></Link>
                            <Link to="/manage-artists" title="Manage Artists" className='text-foreground pr-2'><FaUserEdit size={20} /></Link>
                            <Link to="/manage-data" title="Manage Data" className='text-foreground pr-3'><FaTrash size={20} /></Link>
                            <div onClick={handleUploadFilePopup} title="Upload File" className="cursor-pointer pr-3"><FaUpload size={20} /></div>
                            <div className='relative cursor-pointer' onClick={handleOpenPopup} title="View Requests">
                                <FaBell size={20} className='-10' />
                                {withdrawRequest.length > 0 && (
                                    <div className='absolute left-2 bottom-4 text-center text-xs bg-foreground text-secondary px-2 py-1 rounded-full'>{withdrawRequest.length}</div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Welcome Banner */}
                    <div className="bg-gradient-gold rounded-xl p-6 mb-6">
                        <h2 className="text-primary-white text-xl font-semibold mb-2 ">Welcome, Admin!</h2>
                        <p className="text-muted/80 text-sm mb-3">Here's how overall music is performing across all platforms</p>
                        <div className="flex items-center text-background text-sm space-x-4">
                            <p className='text-secondary '><FaMusic className="inline-block text-secondary/80 mr-1" /> {applicationData ? applicationData.total_platforms : 0} platforms</p>
                            <p className='text-secondary '><FaMusic className="inline-block text-secondary/80 mr-1" /> {applicationData ? applicationData.total_songs : 0} active songs</p>
                            <p className='text-secondary '><FaUser className="inline-block text-secondary/80 mr-1" /> {applicationData ? applicationData.total_artists : 0}  active artists</p>
                            <p className='text-secondary '><FaPhotoVideo className="inline-block text-secondary/80 mr-1" /> {applicationData ? applicationData.total_labels : 0}  active labels</p>
                        </div>
                    </div>

                    {/* Performance Overview */}
                    <div className="mb-8">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-lg font-semibold">
                                <MdGraphicEq className="inline-block mr-2 text-primary" /> Performance Overview
                            </h2>
                            <div className="flex items-center gap-4">
                                <Link to="/advanced-report" className="bg-primary hover:bg-gold-dark text-primary-foreground font-bold py-2 px-4 rounded inline-flex items-center" title="Go to Advanced Reports">
                                    <FaChartBar className="mr-2" />
                                    Advanced Reports
                                </Link>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
                            <PerformanceCard title="Total Songs" value={applicationData ? applicationData.total_songs : 0} icon={<FaMusic className="text-primary" />} increase={performance.songs_increase || 0} />
                            <PerformanceCard title="Total Artists Earnings" value={`₹${(applicationData && applicationData.total_royalty !== undefined) ? applicationData.total_royalty.toFixed(2) : 0}`} icon={<FaMoneyBill className="text-primary" />} increase={performance.royalty_increase || 0} />
                            <PerformanceCard title="Total Views" value={applicationData ? applicationData.total_views : 0} icon={<FaChartBar className="text-primary" />} increase={performance.views_increase || 0} />
                        </div>
                    </div>

                    {/* Monthly Growth & Platform Distribution */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        <PieChartComponent applicationData={applicationData} />
                        <LineChartComponent applicationData={applicationData} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboardPage;